import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-520b93a9"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "wrapperRef",
  class: "custom-select-wrapper"
}
const _hoisted_2 = ["id"]
const _hoisted_3 = ["id", "aria-expanded", "aria-disabled", "aria-labelledby", "aria-controls", "tabindex"]
const _hoisted_4 = { class: "custom-select-trigger" }
const _hoisted_5 = ["disabled", "aria-label", "onClick"]
const _hoisted_6 = {
  key: 1,
  class: "placeholder"
}
const _hoisted_7 = {
  key: 2,
  class: "selected-value"
}
const _hoisted_8 = ["id"]
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = {
  key: 1,
  class: "no-options"
}
const _hoisted_11 = ["aria-multiselectable"]
const _hoisted_12 = ["aria-selected", "disabled", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppError = _resolveComponent("AppError")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          id: _ctx.LABEL_ID,
          class: "select-label"
        }, _toDisplayString(_ctx.label), 9, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      id: _ctx.ID,
      class: _normalizeClass(["custom-select", { open: _ctx.isOpen, disabled: _ctx.disabled }]),
      role: "combobox",
      "aria-expanded": _ctx.isOpen,
      "aria-disabled": _ctx.disabled,
      "aria-labelledby": _ctx.label ? _ctx.LABEL_ID : undefined,
      "aria-controls": _ctx.OPTIONS_ID,
      tabindex: _ctx.disabled ? -1 : 0,
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args))),
      onKeydown: [
        _cache[1] || (_cache[1] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args)), ["prevent"]), ["enter"])),
        _cache[2] || (_cache[2] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args)), ["prevent"]), ["space"])),
        _cache[3] || (_cache[3] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.closeDropdown && _ctx.closeDropdown(...args)), ["prevent"]), ["esc"]))
      ]
    }, [
      _createElementVNode("div", _hoisted_4, [
        (_ctx.multiple && _ctx.selectedOptions.length)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.selectedOptions, (option) => {
              return (_openBlock(), _createElementBlock("span", {
                key: String(option.value),
                class: "selected-tag"
              }, [
                _createTextVNode(_toDisplayString(option.label) + " ", 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "remove",
                  disabled: _ctx.disabled,
                  "aria-label": 'Remove ' + option.label,
                  onClick: _withModifiers(($event: any) => (_ctx.removeOption(option.value)), ["stop"])
                }, " × ", 8, _hoisted_5)
              ]))
            }), 128))
          : _createCommentVNode("", true),
        (!_ctx.selectedOptions.length)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.placeholder), 1))
          : (!_ctx.multiple)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.selectedOptions[0].label), 1))
            : _createCommentVNode("", true)
      ])
    ], 42, _hoisted_3),
    (_ctx.isOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          id: _ctx.OPTIONS_ID,
          class: "custom-options"
        }, [
          (_ctx.showSearchBox)
            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 0,
                ref: "searchInputRef",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.search) = $event)),
                type: "text",
                class: "form-control custom-search",
                placeholder: _ctx.SEARCH_PLACEHOLDER,
                "aria-label": "Search options",
                onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"])),
                onKeydown: _cache[6] || (_cache[6] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.closeDropdown && _ctx.closeDropdown(...args)), ["stop","prevent"]), ["esc"]))
              }, null, 40, _hoisted_9)), [
                [_vModelText, _ctx.search]
              ])
            : _createCommentVNode("", true),
          (_ctx.filteredOptions.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.NO_RESULTS_TEXT), 1))
            : (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "custom-options-list",
                role: "listbox",
                "aria-multiselectable": _ctx.multiple
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredOptions, (option) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: String(option.value),
                    type: "button",
                    class: _normalizeClass(["custom-option", { selected: _ctx.isSelected(option.value) }]),
                    role: "option",
                    "aria-selected": _ctx.isSelected(option.value),
                    disabled: _ctx.disabled,
                    onClick: _withModifiers(($event: any) => (_ctx.selectOption(option)), ["stop"])
                  }, _toDisplayString(option.label), 11, _hoisted_12))
                }), 128))
              ], 8, _hoisted_11))
        ], 8, _hoisted_8))
      : _createCommentVNode("", true),
    _createVNode(_component_AppError, { validations: _ctx.validations }, null, 8, ["validations"])
  ], 512))
}